export const produitsAjoutesPanierProps = () => ({
  articlesIndisponibles: {
    type: Array,
    required: false,
    default: []
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false
  }
})